import {
  BaseIcon
} from "./chunk-Z3LMOCJ7.mjs";

// src/icons/networks/NetworkBinanceSmartChain.tsx
import { forwardRef } from "react";
import { Fragment, jsx } from "react/jsx-runtime";
var NetworkBinanceSmartChain = forwardRef(
  ({ variant = "mono", ...props }, ref) => /* @__PURE__ */ jsx(BaseIcon, { ...props, ref, children: variant === "mono" ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M6.545 5.061 12 2l5.456 3.061-2 1.133L12 4.261 8.55 6.194zm10.91 3.867-2-1.134L12 9.728 8.55 7.794 6.545 8.928v2.26l3.444 1.934v3.861L12 18.117l2.006-1.134v-3.86l3.45-1.934zm0 6.128v-2.267l-2 1.133v2.261zm1.429.8-3.45 1.927v2.267l5.455-3.067v-6.122l-2.005 1.128zm-2.006-8.862 2 1.134v2.26l2.011-1.127V6.994l-2.005-1.133L16.878 7zM9.989 18.606v2.26L12 22l2.006-1.133V18.61L12 19.74l-2.005-1.134zM6.545 15.05l2 1.133v-2.26l-2-1.134v2.267zm3.444-8.056L12 8.128l2.006-1.134L12 5.861 9.995 7zM5.117 8.128l2.005-1.134-2-1.133L3.112 7v2.267l2.005 1.128zm0 3.861L3.11 10.861v6.122l5.456 3.067v-2.272L5.122 15.85v-3.867z"
    }
  ) }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "path",
    {
      fill: "#F0B90B",
      d: "M6.545 5.061 12 2l5.456 3.061-2 1.133L12 4.261 8.55 6.194zm10.91 3.867-2-1.134L12 9.728 8.55 7.794 6.545 8.928v2.26l3.444 1.934v3.861L12 18.117l2.006-1.134v-3.86l3.45-1.934zm0 6.128v-2.267l-2 1.133v2.261zm1.429.8-3.45 1.927v2.267l5.455-3.067v-6.122l-2.005 1.128zm-2.006-8.862 2 1.134v2.26l2.011-1.127V6.994l-2.005-1.133L16.878 7zM9.989 18.606v2.26L12 22l2.006-1.133V18.61L12 19.74l-2.005-1.134zM6.545 15.05l2 1.133v-2.26l-2-1.134v2.267zm3.444-8.056L12 8.128l2.006-1.134L12 5.861 9.995 7zM5.117 8.128l2.005-1.134-2-1.133L3.112 7v2.267l2.005 1.128zm0 3.861L3.11 10.861v6.122l5.456 3.067v-2.272L5.122 15.85v-3.867z"
    }
  ) }) })
);
NetworkBinanceSmartChain.displayName = "binance-smart-chain";
var NetworkBinanceSmartChain_default = NetworkBinanceSmartChain;

export {
  NetworkBinanceSmartChain_default
};
